// A timeslot's cancellationReason is a free-text string that may hold a
// JSON-encoded preset snapshot ({ title, subtext, color }). This helper
// centralizes the "is it a preset?" sniff so consumers don't each re-parse,
// and coerces the fields so a malformed snapshot can't crash rendering.

export type CancellationPreset = { title: string; subtext: string; color: string | null };

export function parseCancellationPreset(
    reason: string | null | undefined,
): CancellationPreset | null {
    if (!reason) return null;
    try {
        const parsed = JSON.parse(reason);
        if (parsed && typeof parsed.title === 'string') {
            return {
                title: parsed.title,
                subtext: typeof parsed.subtext === 'string' ? parsed.subtext : '',
                color: typeof parsed.color === 'string' ? parsed.color : null,
            };
        }
    } catch {
        // plain string, not a preset
    }
    return null;
}
